(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6309],{

/***/ 83767:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26538);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87597);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _Footer_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(87415);
/* harmony import */ var _Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(39181);
/* harmony import */ var _utils_sanitizeHtml__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42770);
"use client";







var Footer = function(param) {
    var aboutData = param.aboutData;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(2025), currentYear = ref[0], setCurrentYear = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isMounted = ref1[0], setIsMounted = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setCurrentYear(new Date().getFullYear());
        setIsMounted(true);
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("footer", {
        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().footer),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().footerContainer),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().footerContent),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().brandSection),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                    href: "/",
                                    "aria-label": "Epen Home",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().logo),
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            style: {
                                                width: "100%"
                                            },
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                src: "/epenlogo.png",
                                                alt: "Epen Logo",
                                                width: 120,
                                                height: 40,
                                                layout: "responsive"
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().subTitle),
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                        variant: "text-sm",
                                        as: "p",
                                        color: "secondary",
                                        weight: "normal",
                                        fontSize: "14px",
                                        children: "Empowering creators with innovative video editing solutions and cutting-edge technologies."
                                    })
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().links),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkGroup),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    variant: "text-lg",
                                                    as: "h3",
                                                    color: "primary",
                                                    weight: "semibold",
                                                    fontSize: "18px",
                                                    children: "Product"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().line9)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkContainer),
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                href: "/video-plugin-framework/vxfx",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    as: "a",
                                                    variant: "text-sm",
                                                    color: "secondary",
                                                    weight: "normal",
                                                    fontSize: "14px",
                                                    className: "".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLink), " ").concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLinkText)),
                                                    children: "VxFx"
                                                })
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkGroup),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    variant: "text-lg",
                                                    as: "h3",
                                                    color: "primary",
                                                    weight: "semibold",
                                                    fontSize: "18px",
                                                    children: "Quick Links"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().line9)
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkContainer),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: "/contact-us",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                        as: "a",
                                                        variant: "text-sm",
                                                        color: "secondary",
                                                        weight: "normal",
                                                        fontSize: "14px",
                                                        className: "".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLink), " ").concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLinkText)),
                                                        children: "Contact Us"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: "/terms-and-conditions",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                        as: "a",
                                                        variant: "text-sm",
                                                        color: "secondary",
                                                        weight: "normal",
                                                        fontSize: "14px",
                                                        className: "".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLink), " ").concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLinkText)),
                                                        children: "Terms of Service"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: "/faq",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                        as: "a",
                                                        variant: "text-sm",
                                                        color: "secondary",
                                                        weight: "normal",
                                                        fontSize: "14px",
                                                        className: "".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLink), " ").concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLinkText)),
                                                        children: "FAQ"
                                                    })
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                                                    href: "/privacy-policy",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                        as: "a",
                                                        variant: "text-sm",
                                                        color: "secondary",
                                                        weight: "normal",
                                                        fontSize: "14px",
                                                        className: "".concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLink), " ").concat((_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().navLinkText)),
                                                        children: "Privacy Policy"
                                                    })
                                                })
                                            ]
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkGroup),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                    variant: "text-lg",
                                                    as: "h3",
                                                    color: "primary",
                                                    weight: "semibold",
                                                    fontSize: "18px",
                                                    children: "Get In Touch"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().line9)
                                                })
                                            ]
                                        }),
                                        aboutData === null || aboutData === void 0 ? void 0 : aboutData.map(function(item, index) {
                                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().linkContainer),
                                                children: [
                                                    item.phone && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactLink),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "/phone.svg",
                                                                loading: "lazy",
                                                                alt: "phone",
                                                                style: {
                                                                    marginTop: 2
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "tel:".concat(item.phone),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                                    variant: "text-sm",
                                                                    as: "div",
                                                                    color: "secondary",
                                                                    weight: "normal",
                                                                    fontSize: "14px",
                                                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactText),
                                                                    children: item.phone
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    item.email && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactLink),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "/email.svg",
                                                                loading: "lazy",
                                                                alt: "email",
                                                                style: {
                                                                    marginTop: 2
                                                                }
                                                            }),
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                                href: "mailto:".concat(item.email),
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                                    variant: "text-sm",
                                                                    color: "secondary",
                                                                    weight: "normal",
                                                                    fontSize: "14px",
                                                                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactText),
                                                                    children: item.email
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    item.address && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactLink),
                                                        children: [
                                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                                                src: "/location.svg",
                                                                loading: "lazy",
                                                                alt: "location",
                                                                style: {
                                                                    marginTop: 2
                                                                }
                                                            }),
                                                            isMounted ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                                variant: "text-sm",
                                                                color: "secondary",
                                                                weight: "normal",
                                                                fontSize: "14px",
                                                                style: {
                                                                    cursor: "auto"
                                                                },
                                                                className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactText),
                                                                dangerouslySetInnerHTML: {
                                                                    __html: (0,_utils_sanitizeHtml__WEBPACK_IMPORTED_MODULE_6__/* .sanitizeRichText */ .b)(item.address)
                                                                }
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                                                                variant: "text-sm",
                                                                color: "secondary",
                                                                weight: "normal",
                                                                fontSize: "14px",
                                                                style: {
                                                                    cursor: "auto"
                                                                },
                                                                className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().contactText),
                                                                children: item.address.replace(/<[^>]*>/g, "")
                                                            })
                                                        ]
                                                    })
                                                ]
                                            }, index);
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().divider),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().line8)
                    })
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().lower),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().legal),
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Typography__WEBPACK_IMPORTED_MODULE_4__/* .Typography */ .ZT, {
                            variant: "text-xs",
                            as: "p",
                            color: "disabled",
                            weight: "normal",
                            className: (_Footer_module_scss__WEBPACK_IMPORTED_MODULE_5___default().copyright),
                            children: [
                                "\xa9 ",
                                currentYear,
                                " Epen Ltd. All Rights Reserved."
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (Footer);


/***/ }),

/***/ 42770:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "b": function() { return /* binding */ sanitizeRichText; }
/* harmony export */ });
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(18030);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_0__);

// Used to sanitize CMS/backend-sourced rich text before it's rendered via
// dangerouslySetInnerHTML - allows common formatting/link markup, strips
// scripts/event handlers/iframes/etc. Works in both SSR and the browser
// (sanitize-html has no DOM dependency, unlike dompurify).
var sanitizeRichText = function(html) {
    if (!html) return "";
    return sanitize_html__WEBPACK_IMPORTED_MODULE_0___default()(html, {
        allowedTags: [
            "p",
            "br",
            "b",
            "strong",
            "i",
            "em",
            "u",
            "s",
            "strike",
            "ul",
            "ol",
            "li",
            "a",
            "span",
            "div",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "blockquote",
            "code",
            "pre",
            "hr",
            "sub",
            "sup"
        ],
        allowedAttributes: {
            a: [
                "href",
                "target",
                "rel"
            ],
            span: [
                "style"
            ],
            div: [
                "style"
            ],
            "*": [
                "class"
            ]
        },
        allowedStyles: {
            "*": {
                color: [
                    /^#[0-9a-fA-F]{3,6}$/,
                    /^rgb\(/
                ],
                "text-align": [
                    /^left$|^right$|^center$/
                ]
            }
        },
        allowedSchemes: [
            "http",
            "https",
            "mailto",
            "tel"
        ],
        transformTags: {
            a: sanitize_html__WEBPACK_IMPORTED_MODULE_0___default().simpleTransform("a", {
                rel: "noopener noreferrer"
            })
        }
    });
};


/***/ }),

/***/ 87415:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"footer":"Footer_footer__Dhw_9","footerContainer":"Footer_footerContainer__vcVmy","footerContent":"Footer_footerContent__Kl_4j","brandSection":"Footer_brandSection__qH7NY","subTitle":"Footer_subTitle__n2rHN","logo":"Footer_logo__By_cG","links":"Footer_links___OZQm","heading":"Footer_heading__J3P7e","linkGroup":"Footer_linkGroup__tkdqJ","line9":"Footer_line9__yKX_k","linkContainer":"Footer_linkContainer__qyR_D","navLink":"Footer_navLink__aJ0uf","navLinkText":"Footer_navLinkText__vH3mX","contactLink":"Footer_contactLink__hSq2A","contactText":"Footer_contactText__VTAxS","divider":"Footer_divider__nrTRf","line8":"Footer_line8__TnJly","lower":"Footer_lower__QRdsF","social":"Footer_social__VBPnO","socialLink":"Footer_socialLink__mnd4G","legal":"Footer_legal__xK_Uq","copyright":"Footer_copyright__lw16R"};

/***/ }),

/***/ 88397:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 91168:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 6993:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 71423:
/***/ (function() {

/* (ignored) */

/***/ })

}]);